export default __webpack_public_path__ + "static/media/tele-plan-carousel-1.92f23f28.png";